import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

@Injectable()
export class CampPromoUploadService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private url = 'api/campPromoUpload';

    constructor(private http: Http) {}

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

    getCampPromoUsers(): Promise<any> {
        const url = `${this.url}/getCampPromoUsers`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    saveCampPromoExcelData(query: any): Promise<any> {
        const url = `${this.url}/saveDetails`;
        return this.http
            .post(url, $.param(query), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    uploadPromoFile(query: any): Promise<any> {
        const url = `${this.url}/uploadPromoFile`;
        return this.http
            .post(url, $.param(query), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/campPromoUpload.service.ts